import React from "react";

const TitleSection = ({ title, desc }) => {
  return (
    <div className="w-full flex flex-col gap-5 text-right">
      <h1 className="text-2xl md:text-4xl font-bold text-[#005BAF]">{title}</h1>
      <p className="text-base md:text-xl text-[#0D171CB2] ">
        {desc}
      </p>
    </div>
  );
};

export default TitleSection;
